import { render, staticRenderFns } from "./DefeactsTable.vue?vue&type=template&id=d6c0d94c&scoped=true&"
import script from "./DefeactsTable.vue?vue&type=script&lang=js&"
export * from "./DefeactsTable.vue?vue&type=script&lang=js&"
import style0 from "./DefeactsTable.vue?vue&type=style&index=0&id=d6c0d94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c0d94c",
  null
  
)

export default component.exports